import React, { useState } from "react";
import { Form, Divider, Button, Input, Card, Alert } from 'antd';
import conditional from "../utils/conditional";
import logosmall from "../media/logo_light.png";
import logodark from "../media/logo_dark.png";
import { useNavigate } from "react-router";
import { apiCall } from "../utils/Api";
import { useSession } from "../utils/Session";
import { objectToPath } from "../utils/Utils";

export default function LoginLayout(props) {

    const { redirect = "" } = props;
    const [session, setSession] = useSession();
    const [error, setError] = useState("")
    const history = useNavigate();

    const login = (_f) => {
        let obj = {
            password: _f.password,
        }
        if (_f.email_address.includes("@")) {
            obj.email_address = _f.email_address;
        } else {
            if (_f.email_address.length !== 7) {
                setError("Use your email address or a 7 digit SAN.");
                return;
            }
            obj.san = _f.email_address;
        }
        if (error) {
            setError("");
        }
        apiCall("account/login", obj, (_status, _result) => {
            if (_status) {
                window.store_id = _result.store_id;
                apiCall("store/getSettings", {}, (_s, _r) => {
                    if (_s) {
                        window.sitesettings = _r;
                        setSession(_result);    
                        let _path = "/purchasing/browse";
                        if(_result.hasOwnProperty("filter_preset_defaults")){
                            if(_result.filter_preset_defaults.hasOwnProperty("status")){
                                _path = "/purchasing/browse" +  objectToPath(session.filter_preset_defaults.status.selections);
                            }
                        }
                        history.push((redirect && redirect !== "/") ? redirect : _path);
                    }
                })
            } else {
                setError(_result.error);
            }
        })
    }

    return (
        <>
            <div className="shim" style={{ "minHeight": "120px", "height" : "calc(50vh - 250px)" }}></div>
            <Card hoverable style={{ "width": "300px", "margin": "0 auto", "border" : "1px solid #e6e6e6" }}>
                <div style={{ "width": "230px", "margin": "0 auto" }}>
                    <div style={{ "width": "230px", "textAlign": "left" }}>
                        <img alt="bookmanager" style={{ "marginLeft": "28px", "height" : "43px" }} width={180} src={(props.dark) ? logodark : logosmall} />
                        <span style={{ "paddingLeft": "0px" }}>
                            <Divider style={{"margin" : "15px 0px"}} dashed />
                        </span>
                    </div>
                    <Form onFinish={(_f) => login(_f)} layout="vertical">
                        <Form.Item label="Email address / SAN" name="email_address" rules={[{ required: true, message: <small>Please input your email or san.</small> }]}>
                            <Input placeholder="Email address..." />
                        </Form.Item>
                        <Form.Item label="Password" name="password" rules={[{ required: true, message: <small>Please input your password.</small> }]}>
                            <Input.Password placeholder="Password..." />
                        </Form.Item>
                        <conditional.true value={(error)}>
                            <Alert
                                style={{ "marginBottom": "20px", "padding": "3px 10px" }}
                                description={error}
                                closable
                                type="error"
                            />
                        </conditional.true>
                        <div style={{ "float": "right" }}>
                            <Button type="primary" htmlType="submit">Sign in</Button>
                        </div>
                    </Form>
                </div>
            </Card>
        </>
    )
}